export const SystemOriginIcon = ({ className, size = 10, ...props }) => (
    <svg
        {...props}
        width={size}
        height={size * 1.2} // Maintain aspect ratio (10x12)
        viewBox="0 0 10 12"
        fill="none"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M3.08301 9.46484L10 5.49219V8.90918L5 11.7979L0 8.90918V6.24219L3.08301 4.46484V9.46484ZM6.97266 6.18652L4 7.88086V4.49219L6.97266 6.18652ZM10 3.13086V4.43652L7.88867 5.63086L3.52734 3.13086L0 5.18652V3.13086L5 0.242188L10 3.13086Z"
            fill="#899CBD"
        />
    </svg>
)

export default SystemOriginIcon
